import { render, staticRenderFns } from "./participateIn.vue?vue&type=template&id=1c320394&scoped=true"
import script from "./participateIn.vue?vue&type=script&lang=js"
export * from "./participateIn.vue?vue&type=script&lang=js"
import style0 from "./participateIn.vue?vue&type=style&index=0&id=1c320394&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c320394",
  null
  
)

export default component.exports